import { z } from 'zod';
import type { Rol } from '../estados';
import type { Permiso } from '../permisos';
import { motivo } from './comunes';

export const loginSchema = z.object({
  usuario: z.string().trim().toLowerCase().min(1, 'Ingresa tu usuario').max(60),
  password: z.string().min(1, 'Ingresa tu contraseña').max(200),
  cliente: z.enum(['web', 'mobile']).default('web'),
  dispositivo: z.string().max(120).optional(),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const refreshSchema = z.object({ refreshToken: z.string().min(20).optional() }).default({});

export const verificarDuenoSchema = z.object({
  usuario: z.string().trim().toLowerCase().min(1).max(60),
  password: z.string().min(1).max(200),
  motivo,
  /** La autorización solo sirve para esta acción (el dueño autoriza algo concreto). */
  accion: z.enum(['desbloqueo_caja', 'cambio_margen']),
});
export type AccionAutorizada = z.infer<typeof verificarDuenoSchema>['accion'];
export type VerificarDuenoInput = z.infer<typeof verificarDuenoSchema>;

export const passwordNueva = z
  .string()
  .min(8, 'La contraseña debe tener al menos 8 caracteres')
  .max(200)
  .regex(/[A-Za-z]/, 'Debe incluir al menos una letra')
  .regex(/\d/, 'Debe incluir al menos un número');

export const cambiarPasswordSchema = z.object({ actual: z.string().min(1), nueva: passwordNueva });

export interface UsuarioSesion {
  id: string;
  nombre: string;
  usuario: string;
  rol: Rol;
  permisos: Permiso[];
  sucursalIds: string[];
}

export interface RespuestaLogin {
  accessToken: string;
  refreshToken?: string;
  usuario: UsuarioSesion;
}
